import { useMemo } from 'react';

import { TextOverlayLockedFeatures } from 'blocks/TextOverlayModal/v2';

import {
  getLockedFeature,
  useEditorState,
} from '../context/VideoEditorStateContext';

/**
 * Resolves the {@link TextOverlayLockedFeatures} for the captions style
 * modal. Returns `undefined` when no lock applies.
 *
 * Scope: only `style.fontFamily` is surfaced today. A whole-style lock
 * (`features.captions.style: DisabledConfig`) is intentionally NOT surfaced
 * — disabling the style group blocks the modal from opening, which is the
 * only way to edit captions style at all. The whole-style lock still
 * implicitly disables fontFamily via the path walk in `getLockedFeature`.
 */
export default function useCaptionsLockedFeatures():
  | TextOverlayLockedFeatures
  | undefined {
  const { features } = useEditorState();

  return useMemo(() => {
    const fontFamily = getLockedFeature(features, [
      'captions',
      'style',
      'fontFamily',
    ]);
    if (!fontFamily) {
      return undefined;
    }
    return { fontFamily };
  }, [features]);
}
